import React, {Component} from 'react'
import {connect} from "react-redux"
import {bindActionCreators} from "redux"
import {UserAction} from "../actions/UserAction"
import {message} from "antd";
import {CommonAction} from "../actions/CommonAction";
import AccountService from "../services/account.service";
import {gaEventWithUserIdLabel, izFalse, LOG_OUT} from "../constants";
import AuthService from "../services/auth.service";
import i18n from "i18next";

class CompanyLicense extends Component {

    componentDidMount() {
        this.getLicense();
    }

    constructor(props) {
        super(props);

        const currentUser = AuthService.getCurrentUser();

        this.state = {
            showLicenseCard: false,
            currentUser: currentUser
        }
    }

    getLicense() {
        AccountService.license()
            .then(
                response => {
                    let success = response.data && response.data.success === true;
                    if (success) {
                        const {companyName, packageMaxSearch, remainingSearchCount, packageEndDate} = response.data.license;
                        this.setState({
                            showLicenseCard: true,
                            companyName: companyName,
                            packageMaxSearch: packageMaxSearch,
                            remainingSearchCount: remainingSearchCount,
                            packageEndDate: packageEndDate,
                        });
                    }
                },
                error => {
                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    } else {
                        gaEventWithUserIdLabel("AccountService.matchAlertSettings Error - " + i18n.t('global_error'))
                        message.error(i18n.t('global_error'))
                    }
                }
            )
    }

    render() {

        const {currentUser, showLicenseCard, companyName, packageMaxSearch, remainingSearchCount, packageEndDate} = this.state;
        if (!currentUser) return "";
        if (izFalse(showLicenseCard)) return "";

        return (
            <>
                <div className="form-box-report company-license  custom-card-border">

                    <div className="row">
                        <div className="col-sm-12 col-md-6">
                            <div className="row">
                                <div className="col-12 text-capitalize">
                                    <strong>{companyName}</strong>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <strong>{currentUser.email}</strong>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6">
                            <div className="row">

                                <div className="col-sm-12 col-md-6 ">
                                    <div className="row">
                                        <div className="col-12 text-center">
                                            <span>{i18n.t('remaining_scan')}</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 text-center">
                                            <strong>{remainingSearchCount + " / " + packageMaxSearch}</strong>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-6 ">
                                    <div className="row">
                                        <div className="col-12 text-center">
                                            <span>{i18n.t('end_date')}</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 text-center">
                                            <strong>{packageEndDate}</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </>
        )
    }

}

function mapStateToProps(state) {
    return {
        common: state.common,
        user: state.user
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        commonAction: CommonAction,
        userAction: UserAction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyLicense);